export default () => ({
  component: 'enabled-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
